import { render, staticRenderFns } from "./AddAgreement.vue?vue&type=template&id=65587e88&scoped=true"
import script from "./AddAgreement.vue?vue&type=script&lang=js"
export * from "./AddAgreement.vue?vue&type=script&lang=js"
import style0 from "./AddAgreement.vue?vue&type=style&index=0&id=65587e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65587e88",
  null
  
)

export default component.exports